import { LOCALSTORAGE_KEYS } from './constants'

// TODO: NO usar, se eliminará
export const getLocalstorageItem = (key, jsonParse) => {
   const value = window.localStorage.getItem(key)
   return jsonParse ? JSON.parse(value) : value
}

// TODO: NO usar, se eliminará
export const setLocalstorageItem = (key, value) => {
   const storedValue = typeof value !== 'string' ? JSON.stringify(value) : value
   window.localStorage.setItem(key, storedValue)
}

// TODO: NO usar, se eliminará
export const removeLocalstorageItem = key => {
   window.localStorage.removeItem(key)
}

export const loadState = () => {
   try {
      const serializedState = getLocalstorageItem(LOCALSTORAGE_KEYS.STATE)
      if (serializedState === null) {
         return {}
      }
      return JSON.parse(serializedState)
   } catch (err) {
      return {}
   }
}

export const saveState = state => {
   if (state?.authenticated === undefined) {
      return
   }
   try {
      const serializedState = JSON.stringify(state)
      setLocalstorageItem(LOCALSTORAGE_KEYS.STATE, serializedState)
   } catch {
      // ignore write errors
   }
}
